import { ActionType, ErrorCode } from "../constants";
import { vidData } from "../utils/videoUtils";
const testing = false;
// # Basic Info
// # First/Last name
// # Email
// # Location (optional)
// # Phone (optional)

// # Resume
// # File Upload

// # Employer Questions
// # (eda jobs table)

//changes:
// rename first_name/last_name
//resume -> resume_id
//questions -> responses

// job_id = application.get('job_id')
// first_name = application.get('first_name')
// last_name = application.get('last_name')
// email = application.get('email')
// location = application.get('location')
// phone = application.get('phone')
// resume_id = application.get('resume_id')
// responses = application.get('responses')
const initialState = {
  app: {
    firstName: "",
    lastName: "",
    email: "",
    location: "",
    phone: "",
    resume: "", // the selected resume from serverData.resumes. [id, name]
    questions: null,
  },
  jobId: null,
  jobData: {},
  serverData: {
    questions: null,
    logoUrl: "",
    aboutCompany: "",
    resumes: [], // list of resumes, [[id, name]]
  },
  missing: [],
  step: 0,

  resumeUrls: {}, // resumeId -> url
  serverCompanyData: {}, // companyId -> {companyData}, very similar to companyProfile.serverCompanyData in EDA

  // applicationAttachments: {}, // currently used in messages but may be used elsewhere
  myApps: {
    loaded: false,
    appIds: [],
    appData: {}, // keyed by jobId
  },
};
export default (state = initialState, action) => {
  try {
    switch (action.type) {
      case ActionType.updateServerCompany:
        const serverCompanyData = { ...state.serverCompanyData };
        Object.keys(action.payload).forEach((companyId) => {
          serverCompanyData[companyId] = {
            ...serverCompanyData[companyId],
            ...action.payload[companyId],
          };
        });
        console.log("updateServerCompany", serverCompanyData);
        return {
          ...state,
          serverCompanyData,
        };
      case ActionType.setResumeUrl:
        return {
          ...state,
          resumeUrls: {
            ...state.resumeUrls,
            [action.payload.resumeId]: action.payload.url,
          },
        };
      case ActionType.setApplyData:
        const { jobId, jobData, serverData, app } = action.payload;
        return {
          ...state,
          app,
          jobId,
          jobData,
          serverData,
        };
      case ActionType.updateAppData:
        return {
          ...state,
          app: { ...state.app, ...action.payload },
        };
      case ActionType.updateApplyServerData:
        return {
          ...state,
          serverData: { ...state.serverData, ...action.payload },
        };
      case ActionType.updateApplyData:
        return {
          ...state,
          ...action.payload,
        };
      case ActionType.setApplicationAttachmentData:
        return {
          ...state,
          myApps: {
            appData: {
              ...state.myApps.appData,
              ...action.payload,
            },
          },
        };
      case ActionType.setMyApps:
        return {
          ...state,
          myApps: {
            loaded: true,
            appIds: action.payload.appIds,
            appData: action.payload.appData,
          },
        };
      default:
        return state;
    }
  } catch (e) {
    console.log("eduReducer error:", e);
  }
};
